import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/header/wechat-qr-code.png")